import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/mom/work-order/{id}/abort`。僅 PROCESSING。
 * body：`abortReason?`、`updatedAt`。
 */
export async function abortWorkOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/mom/work-order/${id}/abort`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
